import FooterEnamadImage from './enamad.svg';
import FooterSamandehiImage from './samandehi.svg';
import FooterEtehadieImage from './etehadie.svg';

export {
  FooterEnamadImage,
  FooterSamandehiImage,
  FooterEtehadieImage,
}
